import { IMenuItem } from '../models/menu-item.model';

/**
 * Seccion del menu lateral. El `caption` es el encabezado que separa grupos
 * (GESTION, CATALOGOS); las secciones sin caption se pintan sin encabezado.
 *
 * Vive aqui y no en `models/menu-item.model.ts` porque es una estructura de
 * datos de la barra lateral, no del contrato del API.
 */
export interface IMenuSection {
  /** Encabezado del grupo. Se dibuja en mayusculas. Opcional. */
  caption?: string;
  /** Entradas del grupo, en orden de lectura. */
  items: IMenuItem[];
}

/**
 * Menu lateral de la consola. Todo el texto va en espanol.
 *
 * FRONTERA DE SEGURIDAD: aqui NUNCA debe aparecer una entrada hacia
 * credenciales, llaves, credenciales compartidas ni etiquetas de la boveda.
 */
export const MENU_SECTIONS: IMenuSection[] = [
  {
    items: [
      {
        label: 'Dashboard',
        icon: 'speedometer2',
        route: '/dashboard',
        exact: true,
      },
    ],
  },
  {
    caption: 'Gestión',
    items: [
      {
        label: 'Usuarios',
        icon: 'people',
        route: '/dashboard/users',
      },
      {
        label: 'Sesiones',
        icon: 'laptop',
        route: '/dashboard/sessions',
      },
    ],
  },
  {
    caption: 'Catálogos',
    items: [
      {
        label: 'Tipos de campo',
        icon: 'ui-checks-grid',
        route: '/dashboard/catalogues/field-types',
      },
      {
        label: 'Plantillas',
        icon: 'file-earmark-text',
        route: '/dashboard/catalogues/templates',
      },
      // El prerellenado («Netflix») pertenece a una plantilla
      // (`PREFILLS.templateId` es FK a `TEMPLATES`) y se crea/edita aqui; cada
      // uno de sus VALORES pertenece a UN campo, asi que ese valor se elige y
      // captura al editar ese campo, dentro del modal del campo.
      {
        label: 'Prerellenados',
        icon: 'bookmarks',
        route: '/dashboard/catalogues/prefills',
      },
    ],
  },
];

/**
 * Vista plana del menu. La usa la barra superior para resolver el icono de la
 * ruta activa sin tener que recorrer las secciones.
 */
export const MENU_ITEMS: IMenuItem[] = MENU_SECTIONS.flatMap((section) => section.items);
